/* global angular */
( function () {
	/* eslint no-undef:0, no-use-before-define:0*/
	'use strict';

	/* eslint-disable max-params */
	function TemplatesPreview ( $scope, $location, logger, apiService, moment, $modal, $routeParams, Session, TITLE, _, $window, $timeout, $rootScope, observationService, TOOLTIP_MESSAGES, INFO, templateservice, evidenceService, type ) {
		/* eslint-enable max-params */
		var self = this;

		self.title = TITLE.templatePreview;

		self.filterBy       = 'Everything';
		self.defaultType    = 'Select a Type';
		self.collapseHeader = true;
		self.tooltip        = TOOLTIP_MESSAGES;

		self.dateData           = {};
		self.endDate            = {};
		self.autoSaving         = false;
		self.activeTimerCount   = 0;
		self.activeCounterCount = 0;
		self.scoreLoading       = false;
		self.printLoading       = false;

		self.dateOptions = {
			'formatYear'  : 'yyyy',
			'startingDay' : 1,
			'showWeeks'   : false
		};

		self.format = 'MM/dd/yy';

		function datePickerEvents ( startDate, endDate ) {
			self.dateData.dt = moment( startDate ).format();
			self.endDate.edt = moment( endDate ).format();

			function startOpen ( $event ) {
				$event.preventDefault();

				$timeout( function () {
					self.startOpened = true;
					self.endOpened   = false;
				}, 0 );
			}

			function endOpen ( $event ) {
				$event.preventDefault();

				$timeout( function () {
					self.endOpened   = true;
					self.startOpened = false;
				}, 0 );
			}

			self.startOpen = startOpen;
			self.endOpen   = endOpen;
		}

		function timePickerEvents ( startDate, endDate ) {
			self.dateData.st = moment( startDate ).format();
			self.endDate.et  = moment( endDate ).format();

			self.hstep = 1;
			self.mstep = 1;

			self.isMeridian = true;

			self.toggleMode = function () {
				self.isMeridian = !self.isMeridian;
			};
		}

		function finalizeDate ( setTo, getFrom ) {
			return moment( setTo ).hours( moment( getFrom ).hours() ).minutes( moment( getFrom ).minutes() ).format();
		}

		$scope.$watch( angular.bind( self, function () {
			return self.endDate.et + self.endDate.edt;
		} ), function ( val ) {
			if ( val && !self.obsData.endDate ) {
				self.obsData.endDate = finalizeDate( self.endDate.edt, self.endDate.et );

				// for endtime: update time/date vice versa
				timePickerEvents( self.obsData.startDate, self.obsData.endDate );
				datePickerEvents( self.obsData.startDate, self.obsData.endDate );
			}
		}, true );

		function validateTemplate () {
			self.obsData.template.creator = _.pick( self.obsData.template.creator, 'id' );

			self.obsData.template.groups.map( function ( group ) {
				delete group.index;
			} );
		}

		function subOptionMask ( subOption ) {
			delete subOption.tempValue;
			delete subOption.selectAll;
		}

		// TODO - needs to be resolved next sprint
		// start of quick fix
		function answerOptionMask ( answerOption ) {
			delete answerOption.tempValue;
			delete answerOption.selectAll;

			( answerOption.subOptions || [] ).map( subOptionMask );
		}

		function indicatorMask ( indicator ) {
			( indicator.answerOptions || [] ).map( answerOptionMask );

			if ( indicator.notApplicable ) {
				delete indicator.score;
			}

			delete indicator.tempValue;
			delete indicator.selectAll;
			delete indicator.evidences;
			delete indicator.prescribedResources;
		}

		function rubricMask ( rubric ) {
			delete rubric.selected;
		}

		function groupMask ( group ) {
			if ( group.rubric ) {
				group.rubric.map( rubricMask );
			}

			delete group.evidences;
			delete group.prescribedResources;
			delete group.score;

			if ( isNaN( group.manualScore ) || group.manualScore < 0 || group.manualScore === '' ) {
				delete group.manualScore;
			}

			( group.indicators || [] ).map( indicatorMask );
		}

		function openEndedMask ( group ) {
			group.indicators.map( function ( indicator ) {
				/* if users try to delete the answer and triggers the autosave
				 * This prevents validation error
				*/
				if ( indicator.answerText === '' ) {
					delete indicator.answerText;
				}
			} );
		}
		// end of quick fix

		function setComputedScore ( printCallback ) {
			var tempObs  = angular.copy( self.obsData );
			var template = angular.copy( self.obsData.template );

			// quick fix for extra attributes passed to api
			if ( template.rubric ) {
				template.rubric.map( rubricMask );
			}

			template.groups.map( groupMask );
			template.groups.map( openEndedMask );

			tempObs.observee = _.pick( self.obsData.observee, 'id' );
			tempObs.observer = _.pick( self.obsData.observer, 'id' );
			tempObs.location = _.pick( self.obsData.location, 'observeeClientId' );
			tempObs.template = template;
			tempObs          = _.omit( tempObs, [ 'score', 'evidences', 'prescribedResources' ] );

			apiService.getObsScore.save( {}, tempObs, function ( data ) {
				// set overall score
				self.obsData.score = data.score;

				// set section score
				_.each( data.template.groups, function ( group, index ) {
					self.obsData.template.groups[ index ].score = group.score;
				} );

				self.scoreLoading = false;

				if ( printCallback ) {
					printCallback();
				}
			}, function ( err ) {
				logger.error( err, '' );
			} );
		}

		function isValidScore ( score ) {
			return angular.isNumber( score );
		}

		function updateObservation ( isClose, printCallback, quickAccess ) {
			self.autoSaveStatus = null;

			self.obsData.startDate = finalizeDate( self.dateData.dt, self.dateData.st );
			self.obsData.endDate   = finalizeDate( self.endDate.edt, self.endDate.et );

			validateTemplate();
			self.scoreLoading = true;
			self.setComputedScore( printCallback );

			if ( quickAccess && quickAccess.evidenceData ) {
				$scope.$broadcast( 'enable:timer:counter:buttons', quickAccess );
				// close add timer/counter modal
				$scope.$emit( 'close:add:modal' );
			}

			if ( quickAccess && quickAccess.type === 7 && quickAccess.fromAdd && !quickAccess.fromAdd.startTimer ) {
				$scope.$broadcast( 'change:label:', quickAccess.evidenceData.id, true );
			}

			// this is to make sure that the displayed score is updated
			$timeout( function () {
				self.scoreLoading = false;
			}, 1000 );
		}

		function printThis () {
			$timeout( function () {
				$window.print();
			}, 500 );
			self.printLoading = false;
		}

		function updatePrintOptions () {
			self.printLoading = true;
			self.updateObs( false, printThis );
		}

		function closePreview () {
			// self.obsData.id === template.id
			return $location.path( '/template/' + self.obsData.id );
		}

		var nullTitle = {
			'title' : ''
		};

		function getProficiency ( group ) {
			var proficiencyTitle = null;

			group.rubric.forEach( function ( proficiency ) {
				if ( group.score > proficiency.minRange && group.score <= proficiency.maxRange ) {
					proficiencyTitle = proficiency.title;
				}
			} );
			return proficiencyTitle || ( group.rubric[ group.rubric.length - 1 ] || nullTitle ).title;
		}

		self.toggleModal = function () {
			$modal.open( {
				'templateUrl'  : '/templates/components/evidences/script/scripting-mode.html',
				'controller'   : 'ScriptingModeController',
				'controllerAs' : 'vm',
				'windowClass'  : 'scripting-modal fade in',
				'resolve'      : {
					'evidences' : function () {
						return self.obsData.evidences;
					},

					'updateObs' : function () {
						return updateObservation;
					},

					'observation' : function () {
						return self.obsData;
					}
				}
			} );
		};

		function getGroups ( groupsData ) {
			$rootScope.$broadcast( 'obs:get:groups', groupsData );
		}

		function toggleTimerNotification ( id ) {
			var index = self.timersActive.indexOf( id );

			if ( index >= 0 ) {
				self.timersActive.splice( index, 1 );

				if ( self.timersActive.length === 0 ) {
					self.runningTimer = false;
				}
			}
		}

		function showPreview ( templateData ) {
			var data = {
				'name'     : 'Observation of ' + Session.getCredentials().LastName + ', ' + Session.getCredentials().FirstName + ' (Preview Mode)',
				'observee' : {
					'id'        : 1662128,
					'firstName' : Session.getCredentials().FirstName,
					'lastName'  : Session.getCredentials().LastName
				},

				'observer' : {
					'id'        : 1662128,
					'firstName' : Session.getCredentials().FirstName,
					'lastName'  : Session.getCredentials().LastName
				},

				'location' : {
					'observeeClientId' : Session.getCredentials().ClientId
				},

				'partialSubmission' : true,
				'startDate'         : moment().format(),
				'endDate'           : moment().add( 1, 'hour' ).format(),
				'masterEvidences'   : [],
				'tags'              : [],
				'template'          : templateData,
				'id'                : templateData.id
			};

			self.isScore      = false;
			self.obsData      = observationService.denormalize( data );
			self.observeeName = self.obsData.observee.lastName + ', ' +  self.obsData.observee.firstName;
			self.observerName = self.obsData.observer.lastName + ', ' +  self.obsData.observer.firstName;

			getGroups( self.obsData.template.groups );
			datePickerEvents( self.obsData.startDate, self.obsData.endDate );
			timePickerEvents( self.obsData.startDate, self.obsData.endDate );

			var index = 0;

			self.obsData.template.groups.map( function ( group ) {
				group.index = index++;

				group.indicators.filter( function ( indicator ) {
					return indicator.notApplicable === undefined && indicator.score !== undefined;
				} ).map( function ( indicator ) {
					indicator.notApplicable = false;
				} );
			} );

			self.obsData.startDate = finalizeDate( self.dateData.dt, self.dateData.st );

			self.loadingObs = false;
			self.updateObs();
		}

		function previewFinalizedTemplate () {
			templateservice.getTemplate( Session.getCredentials().userId, $routeParams.id )
				.then( showPreview, function () {
					$location.path( '/templates' );
					logger.notifyError( 'Unable to fetch template.' );
				} );
		}

		function activate () {
			self.loadingObs = true;

			templateservice.getTemplate( Session.getCredentials().userId, $routeParams.id, type )
				.then( showPreview, previewFinalizedTemplate );

			logger.info( 'Activated Preview Observation View' );
		}

		$scope.$on( 'updateObs', function ( ev, quickAccess ) {
			self.updateObs( false, null, quickAccess );
		} );

		$scope.$on( 'edit:delete:evidences', function ( event, evidence, action ) {
			evidenceService.editDeleteEvidence( evidence, action, self.obsData );
		} );

		self.getProficiency          = getProficiency;
		self.updateObs               = updateObservation;
		self.updatePrintOptions      = updatePrintOptions;
		self.setComputedScore        = setComputedScore;
		self.closePreview            = closePreview;
		self.datePickerEvents        = datePickerEvents;
		self.timePickerEvents        = timePickerEvents;
		self.printThis               = printThis;
		self.timerMsg                = INFO.obsStartTimer;
		self.isValidScore            = isValidScore;
		self.toggleTimerNotification = toggleTimerNotification;
		self.timersActive            = [];

		$scope.$on( 'start:time:', function ( ev, id ) {
			var index = self.timersActive.indexOf( id );

			if ( index === -1 ) {
				self.timersActive.push( id );
			}
			self.runningTimer = true;
		} );

		angular.forEach( [ 'stop:time:', 'delete:timer' ], function ( value ) {
			$scope.$on( value, function ( ev, id ) {
				self.toggleTimerNotification( id );
			} );
		} );

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'TemplatesPreview', TemplatesPreview );

	TemplatesPreview.$inject = [ '$scope', '$location', 'logger', 'apiService', 'moment', '$modal', '$routeParams', 'Session', 'TITLE', '_', '$window', '$timeout', '$rootScope', 'observationService', 'TOOLTIP_MESSAGES', 'INFO', 'templateservice', 'evidenceService', 'tplType' ];
} )();
